// LB-269 — the single place that decides whether Learning Coach is on for a household.
//
// The dark-launch plan is: ship Coach off, prove it, then turn it on for everyone who never
// chose. Step 3 was described as one line. It was not: the household flag was read at 23 sites
// across six client files and one worker file, each testing `settings?.adaptive === true`
// directly, so flipping the default meant editing all 23 — and getting one wrong would leave a
// surface disagreeing with the rest about whether Coach is on.
//
// The other route, defaulting it in migrateState, is worse than it looks. It WRITES true into
// every household's saved state on next load, so removing the line afterwards leaves the value
// persisted everywhere and the change is no longer reversible by releasing again — which is the
// property the plan depends on. It would need a second migration, or the bulk job the plan
// explicitly rules out.
//
// So the default lives here, at read time, and nothing is persisted. Turning Coach on for
// everyone is changing `=== true` to `!== false` in this file and its worker twin, and turning
// it back off is changing it back. Anyone who has explicitly chosen either way is unaffected,
// because an explicit true or false answers both forms the same.
//
// Keep the two files in step: scripts/check-coach-default.mjs fails if they disagree, or if any
// call site goes back to reading the flag directly.
export function coachEnabled(settings) {
  // LB-269 step 3 (Alan, 15 Sep: "enable it now for everyone"). Unset reads as ON. A household
  // that explicitly turned Coach off keeps it off; one that explicitly turned it on is unchanged.
  // A default change, not a job: reversible by releasing this line again.
  return settings?.adaptive !== false;
}
